import React, { useState, useEffect } from "react";
import CertificatePagination from "../../components/pageProps/shopPage/CertificatePagination";
import { Helmet } from "react-helmet";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";

const Certificate = () => {
  const [itemsPerPage, setItemsPerPage] = useState(6);

  useEffect(() => {
    // You can later add dynamic fetching or filtering logic here
  }, []);

  return (
    <div className="max-w-container mx-auto px-4">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Export Certificates - RK Global Trader</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />
        <meta
          name="description"
          content="Download and explore authentic export certificates from RK Global Trader. Ensure product quality, compliance, and international trade certifications for Agriculture, Chilli, Cucumber, Onion, and more."
        />
        <meta
          name="keywords"
          content="RK Global Trader, export certificates, product quality assurance, international trade compliance, agriculture export certificates, export documentation, certified exporters India, global trade, export products"
        />
        <meta
          name="author"
          content="RK Global Trader | Agriculture Product | Export from India"
        />
        <link rel="canonical" href="https://www.rkglobaltrader.com/certificate" />
      </Helmet>

      {/* Breadcrumbs for SEO & Navigation */}
      <Breadcrumbs title="Export Certificates" />

      {/* ================= Certificates Listing Start =================== */}
      <div className="w-full h-full flex flex-col gap-10 pb-20">
        {/* Main Certificate Pagination Component */}
        <div className="w-full mdl:w-[80%] lgl:w-[80%] mx-auto flex flex-col gap-10">
          <CertificatePagination itemsPerPage={itemsPerPage} />
        </div>
      </div>
      {/* ================= Certificates Listing End ===================== */}
    </div>
  );
};

export default Certificate;
